import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import PageBanner from "../components/PageBanner";

export default function PlayerRegister() {
  // Using react-hook-form without TypeScript
  const { register, handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();

  const onSubmit = (data) => {
    // Set initial status and payment status
    const playerData = {
      ...data,
      status: "INACTIVE",  // Default status as requested
      payment: "PENDING"   // Default payment status
    };
    
    console.log(playerData);
    
    // Redirect to success page
    navigate("/register-success", {
      state: {
        name: data.firstName,
      },
    });
  };

  return (
    <>
      <PageBanner
        title="Player Registration"
        subtitle="Register to become a member of Ranipet District Chess Academy"
        image="/images/chess.png"
      />
      
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <h1 className="text-2xl sm:text-3xl font-extrabold text-blue-700 mb-6 sm:mb-8">Player Registration Form</h1>
        
        <form onSubmit={handleSubmit(onSubmit)} className="bg-white p-4 sm:p-8 rounded-xl sm:rounded-2xl shadow-xl border border-gray-100">
          <h2 className="text-lg sm:text-xl font-semibold mb-4 sm:mb-6 text-blue-600 border-b pb-2">Personal Information</h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mb-4">
          <div>
            <label className="block text-gray-700 text-sm mb-1">First Name *</label>
            <input 
              {...register("firstName", { required: "First name is required" })} 
              placeholder="First Name*" 
              className="w-full p-2 sm:p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
            />
            {errors.firstName && <span className="text-red-500 text-xs sm:text-sm">{errors.firstName.message}</span>}
          </div>
          
          <div>
            <label className="block text-gray-700 text-sm mb-1">Middle Name</label>
            <input 
              {...register("middleName")} 
              placeholder="Middle Name" 
              className="w-full p-2 sm:p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
            />
          </div>
          
          <div>
            <label className="block text-gray-700 text-sm mb-1">Last Name *</label>
            <input 
              {...register("lastName", { required: "Last name is required" })} 
              placeholder="Last Name*" 
              className="w-full p-2 sm:p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
            />
            {errors.lastName && <span className="text-red-500 text-xs sm:text-sm">{errors.lastName.message}</span>}
          </div>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4">
          <div>
            <label className="block text-gray-700 text-sm mb-1">Email *</label>
            <input 
              {...register("email", { 
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address"
                }
              })} 
              placeholder="Email*" 
              className="w-full p-2 sm:p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
            />
            {errors.email && <span className="text-red-500 text-xs sm:text-sm">{errors.email.message}</span>}
          </div>
          
          <div>
            <label className="block text-gray-700 text-sm mb-1">Mobile *</label>
            <input 
              {...register("mobile", { 
                required: "Mobile number is required",
                minLength: {
                  value: 10,
                  message: "Mobile number must be 10 digits"
                },
                maxLength: {
                  value: 10,
                  message: "Mobile number must be 10 digits"
                }
              })} 
              placeholder="Mobile*" 
              className="w-full p-2 sm:p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
            />
            {errors.mobile && <span className="text-red-500 text-xs sm:text-sm">{errors.mobile.message}</span>}
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-gray-700 mb-1">Relation Details</label>
            <input 
              {...register("relationDetails")} 
              placeholder="Father/Mother/Guardian Name" 
              className="w-full p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          <div>
            <label className="block text-gray-700 mb-1">Gender</label>
            <select 
              {...register("gender")} 
              className="w-full p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>
        
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Date of Birth</label>
          <input 
            type="date" 
            {...register("dob")} 
            className="w-full p-3 border border-gray-300 rounded-lg 
                       focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Address</label>
          <textarea 
            {...register("address")} 
            placeholder="Full Address" 
            rows={3}
            className="w-full p-3 border border-gray-300 rounded-lg 
                       focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div>
            <label className="block text-gray-700 mb-1">State</label>
            <input 
              {...register("state")} 
              placeholder="State" 
              className="w-full p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          <div>
            <label className="block text-gray-700 mb-1">District</label>
            <input 
              {...register("district")} 
              placeholder="District" 
              className="w-full p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          <div>
            <label className="block text-gray-700 mb-1">Taluk</label>
            <input 
              {...register("taluk")} 
              placeholder="Taluk" 
              className="w-full p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        
        <h2 className="text-xl font-semibold mb-6 text-blue-600 border-b pb-2">Chess IDs</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-gray-700 mb-1">FIDE ID</label>
            <input 
              {...register("fideId")} 
              placeholder="FIDE ID (if any)" 
              className="w-full p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          <div>
            <label className="block text-gray-700 mb-1">AICF ID</label>
            <input 
              {...register("aicfId")} 
              placeholder="AICF ID (if any)" 
              className="w-full p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Player Type</label>
          <select 
            {...register("playerType")} 
            className="w-full p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select Player Type</option>
            <option value="beginner">Beginner</option>
            <option value="intermediate">Intermediate</option>
            <option value="advanced">Advanced</option>
            <option value="expert">Expert</option>
          </select>
        </div>
        
        <h2 className="text-xl font-semibold mb-6 text-blue-600 border-b pb-2">Documents</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-gray-700 mb-1">Photo Upload</label>
            <input 
              type="file" 
              className="w-full p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          <div>
            <label className="block text-gray-700 mb-1">Birth Certificate Upload</label>
            <input 
              type="file" 
              className="w-full p-3 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Create Password *</label>
          <input 
            type="password"
            {...register("password", { 
              required: "Password is required",
              minLength: {
                value: 6,
                message: "Password must be at least 6 characters"
              }
            })} 
            placeholder="Create Password*" 
            className="w-full p-3 border border-gray-300 rounded-lg 
                       focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {errors.password && <span className="text-red-500 text-sm">{errors.password.message}</span>}
        </div>
        
        <div className="mb-4 flex items-center">
          <input 
            type="checkbox" 
            id="terms" 
            className="mr-2"
            required
          />
          <label htmlFor="terms" className="text-gray-700">
            I agree to the terms and conditions
          </label>
        </div>
        
        <button 
          type="submit" 
          className="w-full bg-blue-600 hover:bg-blue-700 
                     text-white px-6 py-3 rounded-xl 
                     font-semibold shadow-md transition-all"
        >
          Register Player
        </button>
      </form>
    </div>
    </>
  );
}